/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StationaryUnitType } from './StationaryUnitType';
import {
    StationaryUnitTypeFromJSON,
    StationaryUnitTypeFromJSONTyped,
    StationaryUnitTypeToJSON,
    StationaryUnitTypeToJSONTyped,
} from './StationaryUnitType';

/**
 * 
 * @export
 * @interface StationaryUnitUpdate
 */
export interface StationaryUnitUpdate {
    /**
     * 
     * @type {string}
     * @memberof StationaryUnitUpdate
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnitUpdate
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {StationaryUnitType}
     * @memberof StationaryUnitUpdate
     */
    stationaryUnitType?: StationaryUnitType | null;
    /**
     * 
     * @type {Date}
     * @memberof StationaryUnitUpdate
     */
    firmwareLastUpdatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnitUpdate
     */
    firmwareCurrentVersion?: string | null;
}



/**
 * Check if a given object implements the StationaryUnitUpdate interface.
 */
export function instanceOfStationaryUnitUpdate(value: object): value is StationaryUnitUpdate {
    return true;
}

export function StationaryUnitUpdateFromJSON(json: any): StationaryUnitUpdate {
    return StationaryUnitUpdateFromJSONTyped(json, false);
}

export function StationaryUnitUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnitUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'stationaryUnitType': json['stationaryUnitType'] == null ? undefined : StationaryUnitTypeFromJSON(json['stationaryUnitType']),
        'firmwareLastUpdatedAt': json['firmwareLastUpdatedAt'] == null ? undefined : (new Date(json['firmwareLastUpdatedAt'])),
        'firmwareCurrentVersion': json['firmwareCurrentVersion'] == null ? undefined : json['firmwareCurrentVersion'],
    };
}

export function StationaryUnitUpdateToJSON(json: any): StationaryUnitUpdate {
    return StationaryUnitUpdateToJSONTyped(json, false);
}

export function StationaryUnitUpdateToJSONTyped(value?: StationaryUnitUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'serialNumber': value['serialNumber'],
        'stationaryUnitType': StationaryUnitTypeToJSON(value['stationaryUnitType']),
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'] == null ? value['firmwareLastUpdatedAt'] : value['firmwareLastUpdatedAt'].toISOString(),
        'firmwareCurrentVersion': value['firmwareCurrentVersion'],
    };
}

